import { Button, TextBase } from '@carboncopyco/ui';

type NoResultsStateProps = {
  onClear: () => void;
};

export const NoResultsState = ({ onClear }: NoResultsStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center gap-2 h-full">
      <TextBase
        label="No results"
        color="text-ds-natural-600"
      />
      <div className="text-center">
        <TextBase
          label="Nothing matches your current search"
          color="text-ds-natural-400"
        />
      </div>
      <div className="pt-1 [&>button]:p-0">
        <Button
          link
          blue
          label="Clear filters"
          onClick={onClear}
        />
      </div>
    </div>
  );
};
